import { Headers } from "../types/api/api.types";

export const full_local_backend_url = "http://localhost:4000";
export const full_test_backend_url = "";
export const full_dev_backend_url = "https://dev-backend.enrollment.nexcaliber.com";
export const full_prod_backend_url = "https://backend.enrollment.nexcaliber.com";
export const full_test_server_backend_url = "https://server.benefitbridz.com/api"; // test-server

// eslint-disable-next-line no-unused-vars
export const local_url = "http://localhost";
export const local_port = "4000";

export const test_prod_url = "https";
export const test_prod_port = "";

export const dev_prod_url = "https";
export const dev_prod_port = "//dev-backend.enrollment.nexcaliber.com";

export const prod_url = "https";
export const prod_port = "//backend.enrollment.nexcaliber.com";

export const test_server_url = "https";
export const test_server_port = "//server.benefitbridz.com/api"; // test-server

// Local, Development and Production Admin Portal URL
export const localAdminUrl = "http://localhost:3000";
export const testAdminUrl = "";
export const devAdminUrl = "https://dev-admin.enrollment.nexcaliber.com";
export const devFirebaseAdminUrl = "https://admin-nexcal.web.app/";
export const prodAdminUrl = "https://admin.enrollment.nexcaliber.com";
export const testServerAdminUrl = "https://server.benefitbridz.com:3000"; // test-server

// Local, Development and Production Node Server URL
export const localServerUrl = "http://localhost:4000";
export const testServerUrl = "";
export const devServerUrl = "https://dev-backend.enrollment.nexcaliber.com";
export const prodServerUrl = "https://backend.enrollment.nexcaliber.com";
export const testServerServerUrl = "https://server.benefitbridz.com/api"; // test-server

// Local, Development and Production Member Portal URL
export const localMemberUrl = "http://localhost:3001";
export const testMemberUrl = "";
export const devMemberPortalUrl = "https://dev-member.enrollment.nexcaliber.com";
export const devFirebaseMemberPortalUrl = "https://member-nexcal.web.app/";
export const prodMemberPortalUrl = "https://member.enrollment.nexcaliber.com";
export const testServerMemberPortalUrl = "https://server.benefitbridz.com:3001"; // test-server

export const MEMBER_ENV: "PROD" | "DEV" | "LOCAL" | "SERVER" = "PROD";

export const MEMBER_PORTAL_LOGIN_REDIRECTION =
	String(MEMBER_ENV) === "PROD"
		? `${prodAdminUrl}/login`
		: String(MEMBER_ENV) === "DEV"
		? `${devAdminUrl}/login`
		: String(MEMBER_ENV) === "LOCAL"
		? `${localAdminUrl}/login`
		: String(MEMBER_ENV) === "SERVER"
		? `${testServerAdminUrl}/login`
		: ""; // Has to change for Dev, local and prod

export const serverUrl =
	String(MEMBER_ENV) === "PROD"
		? prodServerUrl
		: String(MEMBER_ENV) === "DEV"
		? devServerUrl
		: String(MEMBER_ENV) === "LOCAL"
		? localServerUrl
		: String(MEMBER_ENV) === "SERVER"
		? testServerServerUrl
		: ""; // Has to change for Dev, local and prod

export const memberLogoutRedirectionLink =
	String(MEMBER_ENV) === "PROD"
		? prodAdminUrl
		: String(MEMBER_ENV) === "DEV"
		? devAdminUrl
		: String(MEMBER_ENV) === "LOCAL"
		? localAdminUrl
		: String(MEMBER_ENV) === "SERVER"
		? testServerAdminUrl
		: ""; // Has to change for Dev, local and prod

export const adminPortalRedirectionLink =
	String(MEMBER_ENV) === "PROD"
		? prodAdminUrl
		: String(MEMBER_ENV) === "DEV"
		? devFirebaseAdminUrl
		: String(MEMBER_ENV) === "LOCAL"
		? localAdminUrl
		: String(MEMBER_ENV) === "SERVER"
		? testServerAdminUrl
		: ""; // Has to change for Dev, local and prod

export const version = "v1";

export const LINK = "http://localhost:4000/api/v1";

export const headers: Headers = {
	Accept: "application/json",
	"Content-Type": "application/json"
};

export const url =
	String(MEMBER_ENV) === "PROD"
		? prod_url
		: String(MEMBER_ENV) === "DEV"
		? dev_prod_url
		: String(MEMBER_ENV) === "LOCAL"
		? local_url
		: String(MEMBER_ENV) === "SERVER"
		? test_server_url
		: "";
export const port =
	String(MEMBER_ENV) === "PROD"
		? prod_port
		: String(MEMBER_ENV) === "DEV"
		? dev_prod_port
		: String(MEMBER_ENV) === "LOCAL"
		? local_port
		: String(MEMBER_ENV) === "SERVER"
		? test_server_port
		: "";
export const FILE_PORTAL_URL =
	String(MEMBER_ENV) === "PROD"
		? prodServerUrl
		: String(MEMBER_ENV) === "DEV"
		? devServerUrl
		: String(MEMBER_ENV) === "LOCAL"
		? localServerUrl
		: String(MEMBER_ENV) === "SERVER"
		? testServerServerUrl
		: ""; // Has to change for Dev, local and prod
